import * as React from 'react';
import {
    getDayJsInstance,
    isDateRangeEnabled,
    isDateRangeValid,
    setBeginningOfTheDay,
    setEndOfTheDay,
} from '../../../common-utils/date-utils';
import { RangeDateTimePicker } from '../../../ui-lib';

interface IRangeDateTimePickerProps {
    range: number;
    filterByDateFrom?: Date;
    filterByDateTo?: Date;
    setFilterByDateFrom: (filterByDateFrom: Date) => void;
    setFilterByDateTo: (filterByDateTo: Date) => void;
    loading?: boolean;
    onLoad?: () => void;
    disabledDate?: (date: Date) => boolean;
    dateFormat?: string;
    showTime?: boolean;
}

export const ConstrainedDateRangePicker: React.FC<IRangeDateTimePickerProps> = (props: IRangeDateTimePickerProps) => {
    const { range, filterByDateFrom, filterByDateTo, setFilterByDateFrom, setFilterByDateTo, loading, onLoad, dateFormat, showTime } = props;
    const [error, setError] = React.useState(false);
    const [minDate, setMinDate] = React.useState<Date>(filterByDateFrom);
    const [maxDate, setMaxDate] = React.useState<Date>(filterByDateTo);

    const today = new Date();

    const onCalendarChange = (range: 'start' | 'end', startDate: Date, endDate: Date): void => {
        if (range === 'start') {
            setMinDate(showTime ? startDate : setBeginningOfTheDay(startDate));
        } else {
            setMaxDate(showTime ? endDate : setEndOfTheDay(endDate));
        }
    };

    const isSameValue = (date1?: Date, date2?: Date): boolean => (
        showTime ? date1?.getTime() === date2?.getTime() : date1?.toDateString() === date2?.toDateString()
    );

    const onOpenChange = (isOpened: boolean): void => {
        if (isOpened) {
            return;
        }
        if (!isDateRangeValid(range, minDate, maxDate)) {
            setError(true);
            return;
        }
        setError(false);
        if (!isSameValue(filterByDateFrom, minDate) || !isSameValue(filterByDateTo, maxDate)) {
            setFilterByDateFrom(minDate);
            setFilterByDateTo(maxDate);
            onLoad?.();
        }
    };

    return (
        <RangeDateTimePicker
            disabledDate={(date): boolean => (
                !isDateRangeEnabled(date.toDate(), today, range, minDate, maxDate)
            )}
            disabled={loading}
            dateFormat={dateFormat}
            showTime={showTime}
            defaultValues={[getDayJsInstance(minDate), getDayJsInstance(maxDate)]}
            onCalendarChange={onCalendarChange}
            status={error ? 'error' : undefined}
            onOpenChange={onOpenChange}
        />
    );
};
